// https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript

const fallbackCopyToClipboard = (text: string): boolean => {
  const textArea = document.createElement('textarea')
  textArea.value = text

  // Avoid scrolling to bottom
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.position = 'fixed'

  document.body.appendChild(textArea)

  textArea.focus()
  textArea.select()

  try {
    const successful = document.execCommand('copy')

    if (!successful) {
      throw new Error('copy command was unsuccessful')
    }

    document.body.removeChild(textArea)

    return true
  } catch (error) {
    document.body.removeChild(textArea)

    return false
  }
}

export const copyToClipboard = (text: string): boolean => {
  if (!navigator.clipboard) {
    return fallbackCopyToClipboard(text)
  }

  try {
    navigator.clipboard.writeText(text)

    return true
  } catch (error) {
    return false
  }
}
